// Same rules as the apps: unseen messages live 1 h, seen ones the chat's min timer.
export const LONG_MESSAGE_EXPIRY_MS = 60 * 60 * 1000; // unseen: 1 h
export const DEFAULT_TIMER_SECONDS = 120; // backend default per side
// Seen expiry until the chat's min timer is loaded.
export const SHORT_MESSAGE_EXPIRY_MS = DEFAULT_TIMER_SECONDS * 1000;
export const SESSION_DURATION_MS = 6 * 60 * 60 * 1000; // 6 hours
// export const SESSION_DURATION_MS = 60 * 1000; // 1 min (testing)

export const ANDROID_PACKAGE = "nl.phasefour.idlesschat";

export const IOS_STORE_LINK = "https://apps.apple.com/app/1301374134";
export const ANDROID_STORE_LINK =
  "https://play.google.com/store/apps/details?id=YOUR_APP_PACKAGE";